/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";
import jwt_decode, { JwtPayload } from "jwt-decode";
import storage from "utils/storage";

type Payload = JwtPayload & {
  _id: string;
};
export type ImpersonateResponse = {
  token: string;
  user: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    completedWelcome: boolean;
    isDemo: boolean;
    createdAt: string;
    updatedAt: string;
    __v: number;
    org: {
      _id: string;
      name: string;
      members: string[];
      projects: string[];
      createdAt: string;
      updatedAt: string;
      __v: number;
      break: { hours: number; _id: string };
      overtimeAllowed: boolean;
      overtimeHours: number;
    };
    position: string;
    role: string;
  };
};

const impersonateUser = async (
  userId: string
): Promise<ImpersonateResponse> => {
  const { data } = await customAxios.post<ImpersonateResponse>(
    `/users/impersonate/${userId}`
  );
  return data;
};

export const useImpersonateUser = () => {
  const queryClient = useQueryClient();

  return useMutation<ImpersonateResponse, AxiosError, string>({
    mutationFn: impersonateUser,
    onSuccess: async (data) => {
      const orig = storage.getToken();

      if (orig && !storage.getOriginalToken()) {
        storage.setOriginalToken(orig);
      }

      const newWin = window.open(window.location.origin, "_blank");
      if (!newWin) {
        showNotification({
          title: "Impersonation Failed",
          message: "Unable to open new window. Please enable popups.",
          color: "red",
        });
        return;
      }

      const handleReady = (e: MessageEvent) => {
        if (e.origin !== window.location.origin) return;
        if (e.data?.type === "IMPERSONATION_READY") {
          newWin.postMessage(
            {
              type: "IMPERSONATE",
              token: data.token,
              originalToken: orig ?? null,
            },
            window.location.origin
          );
          window.removeEventListener("message", handleReady);
        }
      };
      window.addEventListener("message", handleReady);

      await queryClient.invalidateQueries();
    },
    onError: (error) => {
      showNotification({
        title: "Impersonation Failed",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Unable to impersonate user",
        color: "red",
      });
    },
  });
};
